export default "__VITE_ASSET__CoQaUKYC__"